import client from "@/api";
import store from "@/store";
import { _rotaProdutos, _rotaGetCSVProdutos } from "@/api/_caminhosApi";
import { arrayToFilterString } from "@/utils/array";

export function getCSV(from, to) {
  store.commit("interacoes/SET_LOADING", true);
  client
    .get(_rotaGetCSVProdutos(), {
      params: {
        from,
        to,
      },
      responseType: "blob",
    })
    .then(resp => {
      if (resp.status === 200) {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "produtos.csv");
        document.body.appendChild(link);
        link.click();
      }
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}

export function listarProdutos(from, to, qtd, page, filters) {
  store.commit("interacoes/SET_LOADING", true);
  store.commit("produtos/RESET_PRODUTOS", null);
  client
    .get(`${_rotaProdutos()}`, {
      params: {
        from,
        to,
        per_page: qtd,
        page: page,
        // seller_id: sellerId,
        // affiliate_id: affiliateId,
        filters: arrayToFilterString(filters),
      },
    })
    .then(resp => {
      if (resp.status === 200) {
        store.commit("produtos/SET_PRODUTOS", resp.data);
      }
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}